export const ERROR_LOG_SEVERITY = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
}

type ErrorLogSeverity = 'info' | 'warning' | 'error'

export const errorLogFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Severity__c: 'severity',
  Description__c: 'description',
  Long_Description__c: 'longDescription',
  Case__c: 'caseId'
}

export interface ErrorLog {
  id: string
  severity: ErrorLogSeverity
  description?: string
  longDescription?: string
  caseId?: string
}
